import { Map } from 'immutable';

/**
 * Custom messages for ontrack retail
 */

export default new Map({
    'app.owner': 'OnTrack Retail',
    'app.owner.short': 'OnTrack',
    'preference-centre.privacy-notice':
        'We will not pass on your personal information to any organisation outside of <{app.owner.short}>.',
    'preference-centre.privacy-notice.extra': '_',
    'preference-centre.privacy-notice.more': '_',
    'alertmessage.registration.failed.emailInUse':
        'Registration failed - this account already exists. Please log in or enter a different email address',
    'alertmessage.paymentRegistration.failed.emailInUse':
        'An account with the same email address already exists. Please log in or enter a different email address',
});
